import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import TratorConsulta from 'entity/Trator/components/TratorConsulta'
import TratorForm from 'entity/Trator/components/TratorForm'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-trator"
                route="consulta-trator"

                menuProps={{
                    text: "Tratores",
                    sequence: "111116",
                    iconName: "Agriculture",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<TratorConsulta />}
            />
            <BasicRoute
                uid="trator"
                route="_trator"
                element={<TratorForm />}
            />
        </>
    )
}
